import AppRoot from "./components/AppRoot";
import Home from "./components/Home";
import Stations from "./components/Stations";
import Menu from "./components/Menu";
import News from "./components/News";
import NewsEvents from "./components/NewsEvents";
import NewsStocks from "./components/NewsStocks";
import NewsItem from "./components/NewsItem";
import About from "./components/About";
import Contacts from "./components/Contacts";
import Restaurant from "./components/Restaurant";
import Galleries from "./components/Galleries";
import Gallery from "./components/Gallery";
import NotFound from "./components/NotFound";

let routes = [
    {
        component: AppRoot,
        routes: [
            {
                path: '/',
                exact: true,
                component: Home
            },
            {
                path: '/stations',
                exact: true,
                component: Stations
            },
            {
                path: '/nested/stations',
                exact: true,
                component: Stations
            },
            {
                path: '/menu',
                exact: true,
                component: Menu
            },
            {
                path: '/news',
                exact: true,
                component: News
            },
            {
                path: '/news/page/:page',
                exact: true,
                component: News
            },
            {
                path: '/news/events',
                exact: true,
                component: NewsEvents
            },
            {
                path: '/news/events/page/:page',
                exact: true,
                component: NewsEvents
            },
            {
                path: '/news/stocks',
                exact: true,
                component: NewsStocks,
            },
            {
                path: '/news/stocks/page/:page',
                exact: true,
                component: NewsStocks
            },
            {
                path: '/news/:alias',
                exact: true,
                component: NewsItem
            },
            {
                path: '/galleries',
                exact: true,
                component: Galleries
            },
            {
                path: '/galleries/page/:page',
                exact: true,
                component: Galleries
            },
            {
                path: '/galleries/:alias',
                exact: true,
                component: Gallery
            },
            {
                path: '/about',
                exact: true,
                component: About
            },
            {
                path: '/contacts',
                exact: true,
                component: Contacts
            },
            {
                path: '/restaurants/:alias',
                exact: true,
                component: Restaurant
            },
        ]
    }
];

const languageRoutes = [];


for (let j = 0; j < routes[0].routes.length; j++) {
    if (routes[0].routes[j].path) {
        const path = routes[0].routes[j].path === '/' ? '' : routes[0].routes[j].path;

        languageRoutes.push(Object.assign({}, routes[0].routes[j], {
            path: `/:lang${path}`
        }));
    }
}

routes[0].routes = routes[0].routes.concat(languageRoutes);
routes[0].routes.push({
    component: NotFound
});

export default routes;


// WEBPACK FOOTER //
// ./src/js/routes.js